import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

export default class EditarCategoriaPuedeIntersarte extends Component {

    constructor(props) {
        super(props); 

        this.state = { 
            key: 0,
            categoriaLongitud:0,
            resource: {
                cpin_Nombre:"",
                cpin_Orden: "",
                cpin_Activo: true
            },
            Validacion: {
                cpin_Nombre: {
                    Error: false,                    
                },
                cpin_Orden: {
                    Error: false,                    
                }
            },
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

      componentDidMount()
      {
          if($('#containerPanel').is("*")){
              $('#containerPanel').hide();
          }

            let locationState = this.props.location.state;
            let pathNameList = "/categorias-puede-interesarte";

            var roles = getRoles(this.state.security);
            var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

            validateAccesoGeneral(locationState, pathNameList, rol); 
      }

    componentWillMount(){
        
        var key = this.props.match.params.id;
        const url = `${API_URL}CategoriaPuedeInteresarteUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resource: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            toast.error("¡Error al inicializar!");
        });
    
    }
    
    handleClickCancel(e) {

        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/categorias-puede-interesarte');
     }

     callFunctionButton = (e) => {

        if(e != undefined){
            e.preventDefault();
        }
        
        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.cpin_Nombre == '') {  
            
            newState.Validacion.cpin_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cpin_Orden == '') {  
            newState.Validacion.cpin_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CategoriaPuedeInteresarteUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'cpin_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.handleClickCancel();
                }, 1000);  

                setTimeout(() => { 
                    this.setState({added:false});
                }, 5000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let longitudCategoria = this.state.categoriaLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'cpin_Nombre'){
            longitudCategoria = value.length;
        }
        this.setState({
            resource: copyResource,
            categoriaLongitud: longitudCategoria,
            Validacion: validaciones
        });     
    }

    render() {
        return (
            <div className="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Categoría Puede Intersarte</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Categoría Puede Intersarte
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Categoría" name='cpin_Nombre' value={this.state.resource.cpin_Nombre} maxLength={25} className={this.state.Validacion.cpin_Nombre.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={25}>{this.state.categoriaLongitud}/25</span>
                    </div>
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Orden" name='cpin_Orden' value={this.state.resource.cpin_Orden} maxLength={2} className={this.state.Validacion.cpin_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}
